import { motion } from "framer-motion";
import { Compass } from "lucide-react";

export default function Loader() {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-4">
                <div className="relative">
                    <motion.div
                        animate={{ rotate: 360 }}
                        transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
                        className="text-green-600"
                    >
                        <Compass size={64} strokeWidth={1.5} />
                    </motion.div>
                    {/* Pulsing effect */}
                    <motion.div
                        initial={{ scale: 0.8, opacity: 0.5 }}
                        animate={{ scale: 1.2, opacity: 0 }}
                        transition={{ duration: 1.5, repeat: Infinity }}
                        className="absolute inset-0 bg-green-200 rounded-full -z-10"
                    />
                </div>
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
                    className="text-green-800 font-medium tracking-widest text-sm uppercase"
                >
                    Planning your adventure...
                </motion.p>
            </div>
        </div>
    );
}
